import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TherapistAuthStateService } from '@therapist/shared/services/state/therapist-auth-state.service';

@Component({
  selector: 'sana-tp-mobile-menu-bar',
  imports: [
    RouterLink
  ],
  templateUrl: './mobile-menu-bar.component.html',
  styleUrl: './mobile-menu-bar.component.scss'
})
export class MobileMenuBarComponent {

  readonly #authService = inject(TherapistAuthStateService);

  logout(): void {
    this.#authService.logout();
  }
}
